<template>
  <div>
    <basic-container>
      <!-- //^ ^--------------切换数据类型-------------^ ^ -->
      <el-tabs :value="currentTab" @tab-click="handleTabClick">
        <el-tab-pane label="线上数据" name="online"> </el-tab-pane>
        <el-tab-pane label="本地数据" name="local"></el-tab-pane>
      </el-tabs>
      <!-- //^ ^--------------搜索栏配置-------------^ ^ -->
      <div class="search-contain">
        <div class="search-left">
          <el-input
            v-model="searchParams.name"
            placeholder="请输入策略名称"
            style="width: 200px"
            clearable
          />
          <DynamicOption
            v-model="searchParams.channelId"
            :placeholder="'请选择收端渠道'"
            :singleSelect="true"
            :params="searchOptions"
            style="margin-left: 20px"
          />
          <el-select
            style="margin-left: 20px"
            v-model="searchParams.status"
            clearable
            placeholder="请选择状态"
          >
            <el-option label="启用" :value="1"></el-option>
            <el-option label="禁用" :value="0"></el-option>
          </el-select>
          <el-select
            v-if="currentTab === 'local'"
            style="margin-left: 20px"
            v-model="searchParams.reviewStatus"
            clearable
            placeholder="请选择审核状态"
          >
            <el-option label="草稿" value="1"></el-option>
            <el-option label="待审核" value="2"></el-option>
            <el-option label="通过" value="3"></el-option>
            <el-option label="未通过" value="4"></el-option>
          </el-select>
          <el-select
            style="margin-left: 20px"
            v-model="searchParams.versionTargetType"
            clearable
            placeholder="请选择版本目标类型"
          >
            <el-option
              v-for="opt in versionTargetTypeOptions"
              :key="opt.value"
              :label="opt.label"
              :value="opt.value"
            ></el-option>
          </el-select>
          <el-select
            style="margin-left: 20px"
            v-model="searchParams.endType"
            clearable
            placeholder="请选择配置端"
          >
            <el-option
              v-for="opt in endTypeOptions"
              :key="opt.value"
              :label="opt.label"
              :value="opt.value"
            ></el-option>
          </el-select>
          <el-popover placement="top-start" width="380" trigger="hover">
            <div class="priority-tip">
              <p class="priority-tip__title">策略匹配优先级说明</p>
              <p class="priority-tip__desc">
                一个投屏请求同时符合多条收费策略时，系统只生效优先级最高的一条，从高到低依次匹配：
              </p>
              <ol class="priority-tip__list">
                <li>指定发端渠道 ＋ 指定收端渠道 ＋ 指定版本</li>
                <li>指定发端渠道 ＋ 指定收端渠道 ＋ 版本区间</li>
                <li>指定发端渠道 ＋ 全部收端渠道 ＋ 指定版本</li>
                <li>指定发端渠道 ＋ 全部收端渠道 ＋ 版本区间</li>
                <li>指定发端渠道 ＋ 指定收端渠道 ＋ 不限版本</li>
                <li>指定发端渠道 ＋ 全部收端渠道 ＋ 不限版本</li>
                <li>全部发端渠道 ＋ 指定收端渠道 ＋ 指定版本</li>
                <li>全部发端渠道 ＋ 指定收端渠道 ＋ 版本区间</li>
                <li>全部发端渠道 ＋ 全部收端渠道 ＋ 指定版本</li>
                <li>全部发端渠道 ＋ 全部收端渠道 ＋ 版本区间</li>
                <li>全部发端渠道 ＋ 指定收端渠道 ＋ 不限版本</li>
                <li>全部发端渠道 ＋ 全部收端渠道 ＋ 不限版本</li>
              </ol>
              <p class="priority-tip__rule">
                规则：先看发端渠道（指定优先）→ 再看是否限定版本（限定优先）→ 再看收端渠道（指定优先）→ 最后看版本方式（指定版本优先于版本区间）；同一优先级有多条时取最新配置。
              </p>
            </div>
            <i
              class="el-icon-question"
              slot="reference"
              style="margin-left: 20px; color: #507dc5; cursor: pointer;"
            ></i>
          </el-popover>
        </div>
        <div class="search-right">
          <el-button
            v-auth="'SCREEN_CHARGE_MANAGE_SEARCH'"
            type="primary"
            size="small"
            @click="handleSearch"
            >搜索</el-button
          >
          <el-button
            v-if="currentTab === 'local'"
            v-auth="'SCREEN_CHARGE_MANAGE_ADD'"
            type="primary"
            size="small"
            @click="handleAdd"
            >新增</el-button
          >
        </div>
      </div>
      <!-- //^ ^--------------表格-------------^ ^ -->
      <el-table :key="currentTab" :data="listData" border style="width: 100%; margin-top: 10px" max-height="650">
        <el-table-column prop="id" width="60" label="ID" />
        <el-table-column prop="name" width="150" label="策略名称" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.name || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="receiveChannel"
          width="200"
          label="收端渠道"
        >
          <template slot-scope="scope">
            <span>{{ getReceiveChannel(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="sendChannel"
          width="200"
          label="发端渠道"
        >
          <template slot-scope="scope">
            <span>{{ getSendChannel(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="endType" label="配置端" width="100">
          <template slot-scope="scope">
            <span>{{ endTypeFormatter(scope.row.endType) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="versionTargetType" label="版本目标类型" width="120">
          <template slot-scope="scope">
            <span>{{ versionTargetTypeFormatter(scope.row.versionTargetType) }}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="tvVersion" label="版本号" width="200">
          <template slot-scope="scope">
            <span>{{
              tvVersionFormatter(scope.row.tvVersionType, scope.row.tvVersion)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="pushLimitLabel" label="推送限制" width="200">
          <template slot-scope="scope">
            <span style="white-space: pre-line;">{{ scope.row.pushLimitLabel || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="lanMirrorLimitLabel" label="局域网镜像限制" width="200">
          <template slot-scope="scope">
            <span style="white-space: pre-line;">{{ scope.row.lanMirrorLimitLabel || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="cloudMirrorLimitLabel" label="云镜像限制" width="200">
          <template slot-scope="scope">
            <span style="white-space: pre-line;">{{ scope.row.cloudMirrorLimitLabel || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="imagePushLimitLabel" label="图片推送限制" width="200">
          <template slot-scope="scope">
            <span style="white-space: pre-line;">{{ scope.row.imagePushLimitLabel || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="officeMeetingLimitLabel" label="办公开会限制" width="200">
          <template slot-scope="scope">
            <span style="white-space: pre-line;">{{ scope.row.officeMeetingLimitLabel || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="friendShareLimitLabel" label="好友邀请限制" width="200">
          <template slot-scope="scope">
            <span style="white-space: pre-line;">{{ scope.row.friendShareLimitLabel || '-' }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="dayLimit" label="单日免费投屏次数" width="150">
          <template slot-scope="scope">
            <div style="padding: 9px 0;">{{ formattedDayLimit(scope.row) }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="intervalTimeLabel" label="有效投屏时长" width="150">
          <template slot-scope="scope">
            <span>{{
              scope.row.limitType === 1 ? `${scope.row.intervalTime}秒` : "-"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="dayLimitFreeTime" label="每日体验总时长" width="150">
          <template slot-scope="scope">
            <span>{{
              scope.row.limitType === 2
                ? `${scope.row.dayLimitFreeTime}分钟`
                : "-"
            }}</span>
          </template>
        </el-table-column> -->
        <el-table-column width="80" prop="statusLabel" label="状态">
        </el-table-column>
        <el-table-column v-if="currentTab === 'local'" prop="reviewStatus" label="审核状态" width="80">
          <template slot-scope="{ row }">
            <span v-if="row.reviewStatus == 1">草稿</span>
            <span v-if="row.reviewStatus == 2">待审核</span>
            <span v-if="row.reviewStatus == 3">通过</span>
            <span v-if="row.reviewStatus == 4">未通过</span>
          </template>
      </el-table-column>
        <el-table-column show-overflow-tooltip prop="descr" label="备注">
          <template #default="scope">
            {{ scope.row.descr || '-' }}
          </template>
        </el-table-column>
        <el-table-column v-if="currentTab === 'local'" label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-auth="'SCREEN_CHARGE_MANAGE_EDIT'"
              v-if="scope.row.reviewStatus != 2"
              @click="editEvent(scope.row)"
              type="text"
              size="small"
              >编辑</el-button
            >
            <el-button
              v-auth="'SCREEN_CHARGE_MANAGE_REVIEW'"
              v-if="scope.row.reviewStatus == 1 || !scope.row.reviewStatus"
              type="text"
              size="small"
              @click="submitAudit(scope.row.id)">提交审核</el-button>
            <el-button
              v-auth="'SCREEN_CHARGE_MANAGE_REVOKE_REVIEW'"
              v-if="scope.row.reviewStatus == 2"
              type="text"
              size="small"
              @click="revokeAudit(scope.row.id)">撤销审核</el-button>
            <el-button
              v-auth="'SCREEN_CHARGE_MANAGE_DEL'"
              v-if="scope.row.reviewStatus != 2"
              @click="delEvent(scope.row.id)"
              type="text"
              size="small"
              >删除</el-button
            >
            <el-button
              v-auth="'SCREEN_CHARGE_MANAGE_LOG'"
              type="text"
              size="small"
              @click="viewLog(scope.row)"
              >日志</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <ElementPagination
        style="margin-bottom: 20px"
        :current-page="searchParams.current"
        :page-size="searchParams.size"
        :total="searchParams.total"
        :page-sizes="[10, 20, 30, 40, 50]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
      <!-- 操作日志 -->
      <LogDialog ref="optionLog" :columnConfig="optionLogColumn" @reload="reloadOpt" :closeBtn="false">
        <template #type="{ row }">
          <div>
            <!-- 操作类型(1-新增, 2-修改, 3-删除 -->
            <span v-if="row.type === 1">新增</span>
            <span v-if="row.type === 2">修改</span>
            <span v-if="row.type === 3">删除</span>
            <span v-if="row.type === 4">提交审核</span>
            <span v-if="row.type === 5">撤销审核</span>
            <span v-if="row.type === 6">审核通过</span>
            <span v-if="row.type === 7">审核拒绝</span>
          </div>
        </template>
      </LogDialog>
    </basic-container>
    <!-- //^ ^--------------//^ ^--------------新增对话框-------------^ ^-------------^ ^ -->
    <el-dialog
      :title="isEdit ? '编辑策略' : '新增策略'"
      append-to-body
      :visible.sync="addDialog"
      width="45%"
      @close="closeDialog"
      @open="beforeOpenDialog"
    >
      <el-form
        label-width="135px"
        :model="addForm"
        :rules="rules"
        ref="addForm"
      >
        <el-form-item label="策略名称" prop="name">
          <el-input style="width: 70%" v-model="addForm.name" placeholder="请输入策略名称"></el-input>
        </el-form-item>
        <el-form-item label="配置端" prop="endType">
          <el-radio-group v-model="addForm.endType" @change="handleEndTypeChange">
            <el-radio
              v-for="opt in endTypeOptions"
              :key="opt.value"
              :label="opt.value"
            >{{ opt.label }}</el-radio>
          </el-radio-group>
          <div class="form-tip">
            收端：给接收端（APK/TV）的收费降级策略；发端：给发送端（APP）的收费降级策略。
            下方"收端渠道选择"与"发端渠道选择"是两个独立入口，分别填写接收端（APK/TV）与发送端（APP）的 appId，互不复用。
            除"好友邀请"外，其余权益的策略匹配需两端条件同时满足；"好友邀请"仅按发端渠道匹配，不看收端渠道与版本号。
          </div>
        </el-form-item>
        <el-form-item label="收端渠道选择" prop="channelType">
          <el-radio-group v-model="addForm.channelType">
            <el-radio :label="2">全部渠道</el-radio>
            <el-radio :label="1">指定渠道</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="addForm.channelType === 1" prop="receiveChannel">
          <el-input
            style="width: 70%"
            :autosize="{ minRows: 4, maxRows: 10000 }"
            type="textarea"
            @focus="goSelectChannel"
            v-model="addForm.receiveChannel"
          ></el-input>
        </el-form-item>
        <el-form-item label="发端渠道选择" prop="sendChannelType">
          <el-radio-group v-model="addForm.sendChannelType">
            <el-radio :label="2">全部渠道</el-radio>
            <el-radio :label="1">指定渠道</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="addForm.sendChannelType === 1" prop="sendChannel">
          <el-input
            style="width: 70%"
            :autosize="{ minRows: 4, maxRows: 10000 }"
            type="textarea"
            @focus="goSelectSendChannel"
            v-model="addForm.sendChannel"
          ></el-input>
        </el-form-item>
        <el-form-item label="版本" prop="versionTargetType">
          <el-radio-group v-model="addForm.versionTargetType" @change="handleVersionTargetTypeChange">
            <el-radio
              v-for="opt in versionTargetTypeOptions"
              :key="opt.value"
              :label="opt.value"
            >{{ opt.label }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="versionFieldLabel" prop="tvVersionType">
          <el-radio-group v-model="addForm.tvVersionType">
            <el-radio :label="1">全部版本</el-radio>
            <el-radio :label="2">版本区间</el-radio>
            <el-radio :label="3">指定版本</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="addForm.tvVersionType === 2">
          <div class="tv-version-input">
            <el-form-item prop="tvVersionMin" label="最小版本号（>=）">
              <el-input size="small" v-model="addForm.tvVersionMin" style="width: 120px; margin-right: 10px;"></el-input>
            </el-form-item>
            <el-form-item prop="tvVersionMax" label="最大版本号（<=）">
              <el-input size="small" v-model="addForm.tvVersionMax" style="width: 120px;"></el-input>
            </el-form-item>
          </div>
        </template>
        <template v-else-if="addForm.tvVersionType === 3">
          <el-form-item prop="tvVersionSpecified">
            <el-input
              v-model="addForm.tvVersionSpecified"
              type="textarea"
              placeholder="请输入指定版本号，多个用英文逗号隔开"
              style="width: 70%"
            ></el-input>
          </el-form-item>
        </template>
        <el-form-item label="权益配置" prop="rightConfigGroup" required>
          <el-checkbox-group v-model="addForm.rightConfigGroup">
            <el-checkbox label="1">视频推送</el-checkbox>
            <el-checkbox label="2">局域网镜像</el-checkbox>
            <el-checkbox label="3">云镜像</el-checkbox>
            <el-checkbox label="4">图片推送</el-checkbox>
            <el-checkbox label="5">办公开会</el-checkbox>
            <!-- 好友邀请：只能配在发端策略上，配置端选收端时不可见 -->
            <el-checkbox v-if="showFriendShareRight" label="6">好友邀请</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <PushForm
          ref="pushForm"
          v-show="addForm.rightConfigGroup.includes('1')"
          @mode-change="handleDegradeModeChange('1', $event)"
        />
        <mirror-config title="局域网镜像" v-show="addForm.rightConfigGroup.includes('2')" ref="lanMirrorConfig" degrade-config-type="lanMirror" @mode-change="handleDegradeModeChange('2', $event)"/>
        <mirror-config title="云镜像" v-show="addForm.rightConfigGroup.includes('3')" ref="cloudMirrorConfig" degrade-config-type="cloudMirror" @mode-change="handleDegradeModeChange('3', $event)"/>
        <mirror-config
          title="图片"
          v-show="addForm.rightConfigGroup.includes('4')"
          ref="imageMirrorConfig"
          :default-mode="2"
          :mode1-disabled="true"
          degrade-config-type="image"
          @mode-change="handleDegradeModeChange('4', $event)"
        />
        <mirror-config
          title="办公开会"
          v-show="addForm.rightConfigGroup.includes('5')"
          ref="officeMirrorConfig"
          :default-mode="2"
          :mode1-disabled="true"
          degrade-config-type="officeMeeting"
          @mode-change="handleDegradeModeChange('5', $event)"
        />
        <!--
          好友邀请：只有方式3服务降级（无方式1限次/限时长、无方式2蒙层），
          故不复用 mirror-config 的限制类型选择，直接内嵌降级配置
        -->
        <div class="friend-share-config" v-show="showFriendShareConfig">
          <div class="friend-share-config__title">好友邀请</div>
          <div class="form-tip">
            仅支持"方式3 服务降级"；适用渠道请填上方"发端渠道选择"，不受收端渠道与版本号影响
          </div>
          <DegradeConfig ref="friendShareDegradeConfig" config-type="friendShare" />
        </div>
        <!-- 服务降级(方式3) 策略级公共配置：每天可用高清时长，保存时 fan-out 到每个方式3权益的降级配置 -->
        <el-form-item v-if="hasDegradeMode3" label="每天可用高清时长" prop="strategyDayTime">
          <el-input
            style="width: 200px;"
            v-model="addForm.strategyDayTime"
            placeholder="请输入秒数"
          ></el-input>
          <span class="form-tip" style="display: inline; margin-left: 8px;">秒（所有服务降级方式3权益共用）</span>
        </el-form-item>
        <el-form-item style="margin-top: 10px" label="备注">
          <el-input
            type="textarea"
            v-model="addForm.descr"
            :autosize="{ minRows: 4, maxRows: 10000 }"
            maxlength="9999"
            style="width: 70%"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="addForm.status">
            <el-radio label="1">启用</el-radio>
            <el-radio label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="confirmAdd">确 定</el-button>
      </span>
    </el-dialog>
    <!-- //^ ^--------------多选收端渠道的对话框-------------^ ^ -->
    <channel-popups
      :appId="tempAppId"
      :visible.sync="selectDialog"
      :terminalType.sync="terminalType"
      :vipTypeFilter="channelVipTypeFilter"
      @comfirm="handleSelectConfirm"
    ></channel-popups>
  </div>
</template>

<script>
import {
  getScreenChargeList,
  getScreenChargeListLocal,
  addScreenChargeLocal,
  updateScreenChargeLocal,
  deleteScreenChargeLocal,
  submitAudit,
  cancelAudit,
  getLogList,
} from "@/api/memberNew/screenCharge";
import DynamicOption from "@/components/DynamicOption/index.vue";
import Message from "@/components/Message";
import ChannelPopups from "@/components/channel-popups";
import ElementPagination from "@/components/ElementPagination";
import PushForm from "./components/videoPush.vue";
import LogDialog from '@/components/OptionsLog/optionLog.vue'
import mirrorConfig from "./components/mirrorConfig.vue"
import DegradeConfig from "./components/DegradeConfig.vue"
import { cloneDeep } from 'lodash'

/** 权益配置-好友邀请编码（与后端 MemberConstant.RIGHTS_CONFIGS_FRIEND_SHARE 对齐） */
const RIGHTS_CODE_FRIEND_SHARE = "6";
/** 限制类型-方式3 服务降级（与后端 MemberConstant.LIMIT_TYPE_FUN_3 对齐） */
const LIMIT_TYPE_FUN_DEGRADE = "3";
/** 配置端-发端（与后端 end_type=2 对齐） */
const END_TYPE_SENDER = 2;
/** 渠道选择弹窗当前的选择对象：发端 */
const SELECTION_TYPE_SEND = "send";
/** 渠道选择弹窗当前的选择对象：收端 */
const SELECTION_TYPE_RECEIVE = "receive";

export default {
  name: "WebSassScreenCharge",
  components: {
    DynamicOption,
    ChannelPopups,
    ElementPagination,
    PushForm,
    LogDialog,
    mirrorConfig,
    DegradeConfig,
  },
  data() {
    return {
      /** 当前标签页 */
      currentTab: "local",
      /** 搜索下拉列表数据规定来自收端 */
      searchOptions: {
        terminalType: 2,
      },
      /** 是否为编辑 */
      isEdit: false,
      /** 多选渠道规定为收端 */
      terminalType: 2,
      /** 当前选择渠道类型 'receive' | 'send' */
      currentSelectionType: SELECTION_TYPE_RECEIVE,
      /** 临时存储当前选中的发端/收端的渠道ID，用于传入弹窗进行回显 */
      tempAppId: "",
      /** 多选渠道对话框的显隐 */
      selectDialog: false,
      listData: [],
      /** 搜索参数 */
      searchParams: {
        current: 1,
        size: 10,
        total: "",
        name: "",
        channelId: "",
        status: "",
        reviewStatus: "",
        versionTargetType: "",
        endType: "",
      },
      /**
       * 配置端枚举（与后端 end_type 对齐）
       * 1 = 收端（给接收端 APK/TV 用，默认，兼容存量）
       * 2 = 发端（给发送端 APP 用，适用渠道复用收端渠道入口存 APP appId）
       */
      endTypeOptions: [
        { label: "收端", value: 1 },
        { label: "发端", value: 2 },
      ],
      /**
       * 版本目标类型枚举（与后端字典对齐）
       * 1 = APK 渠道 vipType ∈ {1, 3}（公版APP / 定制APP）
       * 2 = SDK 渠道 vipType ∈ {0, 2}（公版SDK / 定制SDK）
       */
      versionTargetTypeOptions: [
        { label: "APK", value: 1, vipTypeList: [1, 3] },
        { label: "SDK", value: 2, vipTypeList: [0, 2] },
      ],
      /** 新增对话框的显隐 */
      addDialog: false,
      /** 新增对话框内的表单 */
      addForm: {
        /** 策略名称 */
        name: "",
        /** 配置端：1=收端（默认）, 2=发端 */
        endType: 1,
        /** 渠道类型 */
        channelType: 1,
        /** 新增用来显示渠道的  */
        receiveChannel: "",
        /** 新增用来提交渠道的  */
        channelIdList: "",
        channelNameList: [],
        /** 发端渠道类型 */
        sendChannelType: 1,
        /** 发端渠道显示 */
        sendChannel: "",
        /** 发端渠道ID列表 */
        sendChannelIdList: "",
        /** 发端渠道名称列表 */
        sendChannelNameList: [],
        // dayLimit: "0",
        // intervalTime: "0",
        // popupDelayTime: 0,
        // secondPopupDelayTime: 0,

        // /** 推送投屏类型 */
        // limitType: 1,
        // /** 收费投屏类型 */
        // paidCastType: [],
        // /** 每日体验总时长 */
        // dayLimitFreeTime: 0,
        // /** 小黄条显示时长 */
        // yellowBarShowTime: 0,
        // /** 倒计时开始时间 */
        // countdownStartTime: 0,

        /** 状态 */
        status: "",
        /** 备注 */
        descr: "",
        /** 权益类型勾选组 */
        rightConfigGroup: [],
        /** 版本目标类型：1=APK（默认）, 2=SDK */
        versionTargetType: 1,
        /** TV端版本号类型 */
        tvVersionType: 1,
        /** TV端版本号 */
        tvVersionMin: "",
        tvVersionMax: "",
        tvVersionSpecified: "",

        /** 服务降级(方式3) 策略级共用：每天可用高清时长（秒），保存时 fan-out 到各方式3权益 */
        strategyDayTime: "",
      },
      /**
       * 各权益是否处于"方式3-服务降级"（用于策略级 dayTime 显隐/校验）
       * key 与 rightConfigGroup 权益编码一致：1视频推送/2局域网镜像/3云镜像/4图片/5办公开会/6好友邀请
       * 好友邀请只有方式3一种限制类型，故恒为 true（是否参与由 rightConfigGroup 是否勾选决定）
       */
      degradeMode3Flags: { "1": false, "2": false, "3": false, "4": false, "5": false, "6": true },
      /** 操作日志配置列 */
      optionLogColumn: [
        {
          prop: "operateTime",
          label: "操作时间",
        },
        {
          prop: "operator",
          label: "操作人",
        },
        {
          prop: "type",
          label: "操作类型",
          slot: "type",
        },
      ],
      /** 新增对话框内的表单验证规则 */
      rules: {
        name: [
          {
            required: true,
            message: "请输入策略名称",
            trigger: "blur",
          },
        ],
        endType: [
          {
            required: true,
            message: "请选择配置端",
            trigger: ["change", "blur"],
          },
        ],
        channelType: [
          {
            required: true,
            message: "请选择渠道类型",
            trigger: ["change", "blur"],
          },
        ],
        receiveChannel: [
          {
            validator: (rule, value, callback) => {
              if (this.addForm.channelType === 1 && !value) {
                callback(new Error("请选择收端渠道"));
              } else {
                callback();
              }
            },
            trigger: ["change", "blur"],
          },
        ],
        sendChannelType: [
          {
            required: true,
            message: "请选择发端渠道类型",
            trigger: ["change", "blur"],
          },
        ],
        sendChannel: [
          {
            validator: (rule, value, callback) => {
              if (this.addForm.sendChannelType === 1 && !value) {
                callback(new Error("请选择发端渠道"));
              } else {
                callback();
              }
            },
            trigger: ["change", "blur"],
          },
        ],
        status: [
          {
            required: true,
            message: "请选择状态",
            trigger: ["change", "blur"],
          },
        ],

        /** 权益配置 多选项，必选，至少选一个 */
        rightConfigGroup: [
          {
            validator: (rule, value, callback) => {
              if (value.length === 0) {
                callback(new Error("请至少选择一项权益配置"));
              } else {
                callback();
              }
            },
            trigger: ["change", "blur"],
          },
          {
            type: "array",
          },
        ],
        tvVersionMin: [
          {
            validator: this.tvVersionRangeValidator,
            trigger: ["change", "blur"],
          },
        ],
        tvVersionMax: [
          {
            validator: this.tvVersionRangeValidator,
            trigger: ["change", "blur"],
          },
        ],
        tvVersionSpecified: [
          {
            validator: this.tvVersionRangeValidator,
            trigger: ["change", "blur"],
          },
        ],
        /** 策略级每天可用高清时长：仅当存在方式3权益时该表单项渲染并参与校验 */
        strategyDayTime: [
          { required: true, message: "请输入每天可用高清时长", trigger: "blur" },
          { pattern: /^[1-9]\d*$/, message: "请输入大于0的数字", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    /** 版本号输入区的动态 label：APK → "TV端版本号"，SDK → "SDK版本号" */
    versionFieldLabel() {
      return this.addForm.versionTargetType === 2 ? "SDK版本号" : "TV端版本号";
    },
    /**
     * 传给 channel-popups 的 vipType 过滤数组。
     * 收端：按 versionTargetType(APK/SDK) 过滤，保持原行为。
     * 发端：不过滤（返回空数组）—— versionTargetType 是收端版本类型口径
     *      (APK型比 tvAuthInfoDTO.apk_ver、SDK型比 extractSdkVersionForMatch(version)，均取自收端设备)，
     *      发端是手机APP，与收端版本类型无关；过滤会导致 SDK 类渠道(vipType 0/2)选不到。
     */
    channelVipTypeFilter() {
      if (this.currentSelectionType === SELECTION_TYPE_SEND) {
        return [];
      }
      const opt = this.versionTargetTypeOptions.find(
        (item) => item.value === this.addForm.versionTargetType
      );
      return opt ? opt.vipTypeList : [];
    },
    /** 是否存在处于方式3(服务降级)的已选权益，用于策略级 dayTime 显隐/校验 */
    hasDegradeMode3() {
      return this.addForm.rightConfigGroup.some(
        (code) => this.degradeMode3Flags[code]
      );
    },
    /** 好友邀请权益项是否可见：只能配在发端策略上 */
    showFriendShareRight() {
      return this.addForm.endType === END_TYPE_SENDER;
    },
    /** 好友邀请降级配置块是否可见：发端策略 且 已勾选该权益 */
    showFriendShareConfig() {
      return (
        this.showFriendShareRight &&
        this.addForm.rightConfigGroup.includes(RIGHTS_CODE_FRIEND_SHARE)
      );
    },
  },
  created() {
    this.loadList();
  },
  methods: {
    /** 将字符串转换为数组，支持单个值和多个值的情况 */
    stringToArray(value) {
      if (!value) return [];
      // 如果已经是数组，直接返回
      if (Array.isArray(value)) return value;
      // 如果是字符串，按逗号分割
      if (typeof value === 'string' && value.includes(',')) {
        return value.split(',').map(item => item.trim()).filter(item => item);
      }
      // 其他情况转换为字符串数组
      return [String(value)];
    },
    /** 子权益限制方式切换回调：记录该权益是否处于方式3(服务降级) */
    handleDegradeModeChange(rightCode, mode) {
      this.degradeMode3Flags[rightCode] = mode === LIMIT_TYPE_FUN_DEGRADE;
    },
    /**
     * 配置端切换回调：好友邀请只能配在发端策略上，
     * 切到收端时该权益项隐藏，需同步取消勾选并重置其降级配置，避免不可见的配置被提交
     */
    handleEndTypeChange() {
      if (this.showFriendShareRight) {
        return;
      }
      const index = this.addForm.rightConfigGroup.indexOf(RIGHTS_CODE_FRIEND_SHARE);
      if (index === -1) {
        return;
      }
      this.addForm.rightConfigGroup.splice(index, 1);
      this.resetFriendShareDegradeConfig();
      Message.warning("好友邀请仅支持发端策略，已取消该权益勾选");
    },
    /** 重置好友邀请的服务降级配置表单 */
    resetFriendShareDegradeConfig() {
      this.$refs.friendShareDegradeConfig &&
        this.$refs.friendShareDegradeConfig.resetForm();
    },
    /**
     * 收集单个权益的服务降级配置（限制类型包裹组件：视频推送/局域网镜像/云镜像/图片/办公开会）
     */
    buildDegradeConfigData(configComp, rightCode) {
      return this.applyStrategyDayTime(
        configComp.$refs.degradeConfig.getData(),
        rightCode
      );
    },
    /**
     * 方式3权益的 dayTime 统一取策略级输入(addForm.strategyDayTime) fan-out，保证各方式3权益值一致；
     * 非方式3权益保持其自身取值（该字段后端不消费）
     */
    applyStrategyDayTime(degradeConfigData, rightCode) {
      if (this.degradeMode3Flags[rightCode]) {
        degradeConfigData.dayTime =
          this.addForm.strategyDayTime === "" ? null : this.addForm.strategyDayTime;
      }
      return degradeConfigData;
    },
    /**
     * 回显策略级 dayTime：读取各方式3权益(xxxLimitTypeFun==='3')的 dayTime，
     * 取第一个非空值；若各权益值不一致则 console.warn 提示（不阻断）
     */
    resolveStrategyDayTime(row) {
      const degradeSources = [
        { fun: row.pushLimitTypeFun, dto: row.videoPushDegradeConfigDTO },
        { fun: row.lanMirrorLimitTypeFun, dto: row.lanMirrorDegradeConfigDTO },
        { fun: row.cloudMirrorLimitTypeFun, dto: row.cloudMirrorDegradeConfigDTO },
        { fun: row.imagePushLimitTypeFun, dto: row.imagePushDegradeConfigDTO },
        { fun: row.officeMeetingLimitTypeFun, dto: row.officeMeetingDegradeConfigDTO },
        { fun: row.friendShareLimitTypeFun, dto: row.friendShareDegradeConfigDTO },
      ];
      const dayTimes = degradeSources
        .filter((s) => s.fun === LIMIT_TYPE_FUN_DEGRADE && s.dto && s.dto.dayTime != null && s.dto.dayTime !== "")
        .map((s) => String(s.dto.dayTime));
      if (dayTimes.length === 0) {
        return "";
      }
      const uniqueDayTimes = [...new Set(dayTimes)];
      if (uniqueDayTimes.length > 1) {
        console.warn("[服务降级] 各方式3权益的每天可用高清时长(dayTime)不一致:", dayTimes, "已取第一个值回显");
      }
      return dayTimes[0];
    },
    /** 加载投屏收费数据 */
    async loadList() {
      try {
        const res = this.currentTab === "local" ? await getScreenChargeListLocal(this.searchParams) : await getScreenChargeList(this.searchParams);
        console.log("加载投屏收费数据的响应", res.data.records);
        this.searchParams.total = res.data.total;

        /** 数据改造 */
        let list = res.data.records.map((obj) => {
          const receiveChannel = obj.channelNameList.reduce(
            (acc, name, index) => {
              const channelId = obj.channelIdList[index];
              const channel = `(${channelId})${name}`;
              return acc ? `${acc},${channel}` : channel;
            },
            ""
          );
          
          const sendChannel = (obj.senderChannelNameList || []).reduce(
            (acc, name, index) => {
              const channelId = (obj.senderChannelIdList || [])[index];
              const channel = `(${channelId})${name}`;
              return acc ? `${acc},${channel}` : channel;
            },
            ""
          );

          const intervalTimeLabel = obj.intervalTime + "秒";
          const statusLabel = obj.status === 1 ? "启用" : "禁用";

          // 云镜像限制类型列表
          const cloudMirrorLimitTypeList = obj.cloudMirrorLimitType.split(",");
          // 局域网镜像限制类型列表
          const lanMirrorLimitTypeList = obj.lanMirrorLimitType.split(",");
          // 视频推送类型
          const pushLimitTypeList = obj.pushLimitType.split(",");
          // 权益配置
          const rightsConfigsList = obj.rightsConfigs.split(",");

          // 构建视频推送限制标签（权益配置 1-视频推送）
          let pushLimitLabel = '-';
          if (rightsConfigsList.includes('1')) {
            // 判断是否为方式2（限制全屏播放）
            // 兼容逻辑：pushLimitTypeFun 为新的字段，'6' 为旧的数据中的蒙层遮盖/全屏限制标记
            const isRestrictionMode2 = obj.pushLimitTypeFun === '2' || pushLimitTypeList.includes('6');
            const parts = [];
            
            if (isRestrictionMode2) {
               // 方式2：限制全屏播放，展示试看时长
               parts.push('方式2:');
               parts.push(`限制全屏播放 (试看: ${obj.pushFullFreeDuration || 0} 秒)`);
            } else if (obj.pushLimitTypeFun === '3') {
               // 方式3：服务降级
               parts.push('方式3:');
               const dDto = obj.videoPushDegradeConfigDTO || {};
               parts.push(`高清时长: ${dDto.dayTime || 0}秒`);
               const degradeLabel = dDto.degradeType === 0 ? '降低服务质量' : '直接停止';
               parts.push(`降级方式: ${degradeLabel}`);
               if (dDto.degradeType === 0) {
                 if (dDto.stutterTime) parts.push(`卡顿: ${dDto.stutterTime}次/${dDto.stutterCycle || 0}秒周期, 单次${dDto.stutterDuration || 0}秒`);
               }
               if (dDto.haveTimeYellowBarShowTime) parts.push(`剩余时间提示时机: ${dDto.haveTimeYellowBarShowTime}`);
               if (dDto.haveTimeYellowBarShowContent) parts.push(`剩余时间展示文案: ${dDto.haveTimeYellowBarShowContent}`);
               if (dDto.expiredYellowBarShowTime) parts.push(`到期后展示时机: ${dDto.expiredYellowBarShowTime}`);
               if (dDto.expiredCurrentSessionYellowBarShowContent) parts.push(`(本次投屏)到期后展示文案: ${dDto.expiredCurrentSessionYellowBarShowContent}`);
               if (dDto.expiredNextSessionYellowBarShowContent) parts.push(`(下次投屏)到期后展示文案: ${dDto.expiredNextSessionYellowBarShowContent}`);
            } else {
               // 方式1：基础限制，展示限次、限时、限清晰度
               parts.push('方式1:');
               // 1: 限次
               if (pushLimitTypeList.includes('1')) parts.push(`限次：${obj.dayLimit || 0} 次`);
               // 2: 限总时长
               if (pushLimitTypeList.includes('2')) parts.push(`限总时长：${obj.dayLimitFreeTime || 0} 分钟`);
               // 3: 限清晰度
               if (pushLimitTypeList.includes('3')) parts.push(`限清晰度：${obj.clarityW}x${obj.clarityH}`);
            }


            pushLimitLabel = parts.length > 0 ? parts.join('\n') : '-';
          }

          // 构建局域网镜像限制标签（权益配置 2-局域网镜像）
          let lanMirrorLimitLabel = '-';
          if (rightsConfigsList.includes('2')) {
            // 判断是否为方式2（蒙层遮盖）
            // 兼容逻辑：lanMirrorLimitTypeFun 为新的字段，'6' 为旧的数据中的蒙层遮盖标记
            const isRestrictionMode2 = obj.lanMirrorLimitTypeFun === '2' || lanMirrorLimitTypeList.includes('6');
            const parts = [];

            if(isRestrictionMode2) {
               // 方式2：蒙层遮盖，从DTO中获取详情
               parts.push('方式2:');
               const dto = obj.lanMirrorShadeLayerConfigDTO || {};
               parts.push(`蒙层遮盖 (单次限制: ${dto.shadeSingleDuration || 0} 秒)`);
            } else if (obj.lanMirrorLimitTypeFun === '3') {
               // 方式3：服务降级
               parts.push('方式3:');
               const dDto = obj.lanMirrorDegradeConfigDTO || {};
               parts.push(`高清时长: ${dDto.dayTime || 0}秒`);
               const degradeLabel = dDto.degradeType === 0 ? '降低服务质量' : '直接停止';
               parts.push(`降级方式: ${degradeLabel}`);
               if (dDto.degradeType === 0 && dDto.resolution) {
                 parts.push(`分辨率限制: ${dDto.resolution}`);
               }
               if (dDto.haveTimeYellowBarShowTime) parts.push(`剩余时间提示时机: ${dDto.haveTimeYellowBarShowTime}`);
               if (dDto.haveTimeYellowBarShowContent) parts.push(`剩余时间展示文案: ${dDto.haveTimeYellowBarShowContent}`);
               if (dDto.expiredYellowBarShowTime) parts.push(`到期后展示时机: ${dDto.expiredYellowBarShowTime}`);
               if (dDto.expiredCurrentSessionYellowBarShowContent) parts.push(`(本次投屏)到期后展示文案: ${dDto.expiredCurrentSessionYellowBarShowContent}`);
               if (dDto.expiredNextSessionYellowBarShowContent) parts.push(`(下次投屏)到期后展示文案: ${dDto.expiredNextSessionYellowBarShowContent}`);
            } else {
               // 方式1：基础限制
               parts.push('方式1:');
               if (lanMirrorLimitTypeList.includes('1')) parts.push(`限次：${obj.lanMirrorDailyFrequency || 0} 次`);
               if (lanMirrorLimitTypeList.includes('2')) parts.push(`限单次时长：${obj.lanMirrorSingleDurationMin || 0} 分钟`);
               if (lanMirrorLimitTypeList.includes('3')) {
                 const lanResolution = obj.lanMirrorDefinitionLimitFlag === '1' ? '720P' : '不限制';
                 parts.push(`限清晰度：${lanResolution}`);
               }
            }


            lanMirrorLimitLabel = parts.length > 0 ? parts.join('\n') : '-';
          }

          // 构建云镜像限制标签（权益配置 3-云镜像）
          let cloudMirrorLimitLabel = '-';
          if (rightsConfigsList.includes('3')) {
            // 判断是否为方式2（蒙层遮盖）
            const isRestrictionMode2 = obj.cloudMirrorLimitTypeFun === '2' || cloudMirrorLimitTypeList.includes('6');
            const parts = [];

            if(isRestrictionMode2) {
              // 方式2详情
              parts.push('方式2:');
              const dto = obj.cloudMirrorShadeLayerConfigDTO || {};
              parts.push(`蒙层遮盖 (单次限制: ${dto.shadeSingleDuration || 0} 秒)`);
            } else if (obj.cloudMirrorLimitTypeFun === '3') {
              // 方式3
              parts.push('方式3:');
              const dDto = obj.cloudMirrorDegradeConfigDTO || {};
              parts.push(`高清时长: ${dDto.dayTime || 0}秒`);
              parts.push(`降级方式: 直接停止`);
              if (dDto.haveTimeYellowBarShowTime) parts.push(`剩余时间提示时机: ${dDto.haveTimeYellowBarShowTime}`);
              if (dDto.haveTimeYellowBarShowContent) parts.push(`剩余时间展示文案: ${dDto.haveTimeYellowBarShowContent}`);
              if (dDto.expiredYellowBarShowTime) parts.push(`到期后展示时机: ${dDto.expiredYellowBarShowTime}`);
              if (dDto.expiredCurrentSessionYellowBarShowContent) parts.push(`(本次投屏)到期后展示文案: ${dDto.expiredCurrentSessionYellowBarShowContent}`);
              if (dDto.expiredNextSessionYellowBarShowContent) parts.push(`(下次投屏)到期后展示文案: ${dDto.expiredNextSessionYellowBarShowContent}`);
            } else {
              // 方式1详情
              parts.push('方式1:');
              if (cloudMirrorLimitTypeList.includes('1')) parts.push(`限次：${obj.cloudMirrorDailyFrequency || 0} 次`);
              if (cloudMirrorLimitTypeList.includes('2')) parts.push(`限单次时长：${obj.cloudMirrorSingleDurationMin || 0} 分钟`);
              if (cloudMirrorLimitTypeList.includes('3')) {
                const cloudResolution = obj.cloudMirrorDefinitionLimitFlag === '1' ? '720P' : '不限制';
                parts.push(`限清晰度：${cloudResolution}`);
              }        
            }


            cloudMirrorLimitLabel = parts.length > 0 ? parts.join('\n') : '-';
          }

          // 构建图片推送限制标签（权益配置 4-图片推送）
          // imagePushLimitLabel 只支持方式2（蒙层遮盖），无方式1逻辑，但需保留"方式2"标识
          let imagePushLimitLabel = '-';
          if (rightsConfigsList.includes('4')) {
            const parts = [];
            if (obj.imagePushLimitTypeFun === '3') {
               parts.push('方式3:');
               const dDto = obj.imagePushDegradeConfigDTO || {};
               parts.push(`高清时长: ${dDto.dayTime || 0}秒`);
               const degradeLabel = dDto.degradeType === 0 ? '降低服务质量' : '直接停止';
               parts.push(`降级方式: ${degradeLabel}`);
               if (dDto.degradeType === 0 && dDto.compression) {
                 parts.push(`画质压缩: ${dDto.compression}%`);
               }
               if (dDto.haveTimeYellowBarShowTime) parts.push(`剩余时间提示时机: ${dDto.haveTimeYellowBarShowTime}`);
               if (dDto.haveTimeYellowBarShowContent) parts.push(`剩余时间展示文案: ${dDto.haveTimeYellowBarShowContent}`);
               if (dDto.expiredYellowBarShowTime) parts.push(`到期后展示时机: ${dDto.expiredYellowBarShowTime}`);
               if (dDto.expiredCurrentSessionYellowBarShowContent) parts.push(`(本次投屏)到期后展示文案: ${dDto.expiredCurrentSessionYellowBarShowContent}`);
               if (dDto.expiredNextSessionYellowBarShowContent) parts.push(`(下次投屏)到期后展示文案: ${dDto.expiredNextSessionYellowBarShowContent}`);
            } else {
               const dto = obj.imagePushShadeLayerConfigDTO || {};
               // 展示蒙层遮盖详情，带上"方式2:"前缀
               parts.push('方式2:');
               parts.push(`蒙层遮盖 (单次限制: ${dto.shadeSingleDuration || 0} 秒)`);
            }
            imagePushLimitLabel = parts.join('\n');
          }

          // 构建办公开会限制标签（权益配置 5-办公开会）
          // officeMeetingLimitLabel 只支持方式2（蒙层遮盖），无方式1逻辑，但需保留"方式2"标识
          let officeMeetingLimitLabel = '-';
          if (rightsConfigsList.includes('5')) {
             const parts = [];
             if (obj.officeMeetingLimitTypeFun === '3') {
                parts.push('方式3:');
                const dDto = obj.officeMeetingDegradeConfigDTO || {};
                parts.push(`高清时长: ${dDto.dayTime || 0}秒`);
                parts.push(`降级方式: 直接停止`);
                if (dDto.haveTimeYellowBarShowTime) parts.push(`剩余时间提示时机: ${dDto.haveTimeYellowBarShowTime}`);
                if (dDto.haveTimeYellowBarShowContent) parts.push(`剩余时间展示文案: ${dDto.haveTimeYellowBarShowContent}`);
                if (dDto.expiredYellowBarShowTime) parts.push(`到期后展示时机: ${dDto.expiredYellowBarShowTime}`);
                if (dDto.expiredCurrentSessionYellowBarShowContent) parts.push(`(本次投屏)到期后展示文案: ${dDto.expiredCurrentSessionYellowBarShowContent}`);
                if (dDto.expiredNextSessionYellowBarShowContent) parts.push(`(下次投屏)到期后展示文案: ${dDto.expiredNextSessionYellowBarShowContent}`);
             } else {
                const dto = obj.officeMeetingShadeLayerConfigDTO || {};
                // 展示蒙层遮盖详情，带上"方式2:"前缀
                parts.push('方式2:');
                parts.push(`蒙层遮盖 (单次限制: ${dto.shadeSingleDuration || 0} 秒)`);
             }
             officeMeetingLimitLabel = parts.join('\n');
          }

          // 构建好友邀请限制标签（权益配置 6-好友邀请）
          // 好友邀请只有方式3服务降级，降级配置与局域网镜像同构（降级方式可选、支持分辨率限制与到期后 3 项）
          let friendShareLimitLabel = '-';
          if (rightsConfigsList.includes(RIGHTS_CODE_FRIEND_SHARE)) {
            const parts = [];
            if (obj.friendShareLimitTypeFun === LIMIT_TYPE_FUN_DEGRADE) {
              parts.push('方式3:');
              const dDto = obj.friendShareDegradeConfigDTO || {};
              parts.push(`高清时长: ${dDto.dayTime || 0}秒`);
              const degradeLabel = dDto.degradeType === 0 ? '降低服务质量' : '直接停止';
              parts.push(`降级方式: ${degradeLabel}`);
              if (dDto.degradeType === 0 && dDto.resolution) {
                parts.push(`分辨率限制: ${dDto.resolution}`);
              }
              if (dDto.haveTimeYellowBarShowTime) parts.push(`剩余时间提示时机: ${dDto.haveTimeYellowBarShowTime}`);
              if (dDto.haveTimeYellowBarShowContent) parts.push(`剩余时间展示文案: ${dDto.haveTimeYellowBarShowContent}`);
              if (dDto.expiredYellowBarShowTime) parts.push(`到期后展示时机: ${dDto.expiredYellowBarShowTime}`);
              if (dDto.expiredCurrentSessionYellowBarShowContent) parts.push(`(本次投屏)到期后展示文案: ${dDto.expiredCurrentSessionYellowBarShowContent}`);
              if (dDto.expiredNextSessionYellowBarShowContent) parts.push(`(下次投屏)到期后展示文案: ${dDto.expiredNextSessionYellowBarShowContent}`);
            }
            friendShareLimitLabel = parts.length > 0 ? parts.join('\n') : '-';
          }

          return {
            ...obj, 
            receiveChannel, 
            sendChannel,
            intervalTimeLabel, 
            statusLabel, 
            cloudMirrorLimitTypeList, 
            lanMirrorLimitTypeList, 
            pushLimitTypeList, 
            rightsConfigsList, 
            pushLimitLabel, 
            cloudMirrorLimitLabel, 
            lanMirrorLimitLabel, 
            imagePushLimitLabel,
            officeMeetingLimitLabel,
            friendShareLimitLabel
          };
        });

        this.listData = list;
      } catch (error) {
        console.log("加载投屏收费数据失败", error);
      }
    },
    /** 点击搜索按钮事件 */
    async handleSearch() {
      console.log("搜索参数", this.searchParams);
      await this.loadList();
      Message.success("搜索成功");
    },
    /** 点击新增按钮事件 */
    handleAdd() {
      /** 显式声明为新增，不依赖上次 closeDialog 兜底重置 isEdit */
      this.isEdit = false;
      this.addDialog = true;
    },
    //^ ^--------------分页相关 start-------------^ ^
    /** 每页条数change */
    handleSizeChange(val) {
      this.searchParams.size = val;
      Message.success(`每页 ${val} 条`);
      /** 更新数据 */
      this.loadList();
    },
    /** 当前页change */
    handleCurrentChange(val) {
      this.searchParams.current = val;
      Message.success(`当前页 ${val}`);
      /** 更新数据 */
      this.loadList();
    },
    //^ ^--------------表格内的事件-------------^ ^
    /** 编辑按钮的事件 */
    editEvent(row) {
      console.log("编辑事件", row);
      /** 确认为编辑 */
      this.isEdit = true;
      /** 回填数据 */
      this.addForm = {
        id: row.id,
        name: row.name,
        /** 配置端回显：null/undefined 默认收端(1)，兼容存量数据 */
        endType: row.endType || 1,
        channelType: row.channelType,
        receiveChannel: row.receiveChannel,
        channelIdList: row.channelIdList.join(","),
        channelNameList: row.channelNameList.join(","),
        
        sendChannelType: row.senderChannelType || 1,
        sendChannelIdList: (row.senderChannelIdList || []).join(","),
        sendChannelNameList: (row.senderChannelNameList || []).join(","),
        // 构建显示的sendChannel字符串
        sendChannel: row.sendChannel,
        // intervalTime: row.intervalTime,
        // popupDelayTime: Number(row.popupDelayTime) || 0,
        // secondPopupDelayTime: Number(row.secondPopupDelayTime) || 0,
        status: String(row.status),
        descr: row.descr,
        rightConfigGroup: row.rightsConfigsList,
        /** 服务降级(方式3) 策略级 dayTime 回显：读方式3权益的 dayTime，不一致告警 */
        strategyDayTime: this.resolveStrategyDayTime(row),

        /** 版本目标类型回显：null/undefined 默认 APK(1)，兼容存量数据 */
        versionTargetType: row.versionTargetType || 1,
        tvVersionType: row.tvVersionType || 1,
        // limitType: row.limitType || 1,
        // paidCastType: this.stringToArray(row.paidCastType),
        // dayLimitFreeTime: row.dayLimitFreeTime || 0,
        // yellowBarShowTime: row.yellowBarShowTime || 0,
        // countdownStartTime: row.countdownStartTime || 0,
        ...this.tvVersionSplitHandler(
          row.tvVersionType || 1,
          row.tvVersion || ""
        ),
      };
      /**
       * 方式3(服务降级)标记同步回显：只读 row.*LimitTypeFun，不依赖任何子组件 $refs，
       * 与 addForm 其它字段同一时机整体覆盖赋值。
       * 与 @open(beforeOpenDialog) 的重置时序解耦——beforeOpenDialog 已按 isEdit 跳过编辑场景的 flags 重置，
       * 故此处同步赋值不会被 @open 重置覆盖，也不再依赖 nextTick 回调相对 @open 的调度先后。
       */
      this.degradeMode3Flags = {
        "1": row.pushLimitTypeFun === LIMIT_TYPE_FUN_DEGRADE,
        "2": row.lanMirrorLimitTypeFun === LIMIT_TYPE_FUN_DEGRADE,
        "3": row.cloudMirrorLimitTypeFun === LIMIT_TYPE_FUN_DEGRADE,
        "4": row.imagePushLimitTypeFun === LIMIT_TYPE_FUN_DEGRADE,
        "5": row.officeMeetingLimitTypeFun === LIMIT_TYPE_FUN_DEGRADE,
        /** 好友邀请只有方式3，恒为 true */
        "6": true,
      };
      this.$nextTick(() => {
        // 视频推送
        this.$refs.pushForm.videoPushForm.restrictionTypes = this.stringToArray(row.pushLimitType);

        if (row.dayLimit === -1) {
          this.$refs.pushForm.videoPushForm.dayLimit = "";
        } else {
          this.$refs.pushForm.videoPushForm.dayLimit = String(row.dayLimit);
        }
        this.$refs.pushForm.videoPushForm.intervalTime = row.intervalTime;
        this.$refs.pushForm.videoPushForm.popupDelayTime =
          Number(row.popupDelayTime) || 0;
        this.$refs.pushForm.videoPushForm.secondPopupDelayTime =
          Number(row.secondPopupDelayTime) || 0;
        // 方式1-限次-小黄条配置回显
        this.$refs.pushForm.videoPushForm.pushCountLimitYellowBarShowTime = row.pushCountLimitYellowBarShowTime || "";
        this.$refs.pushForm.videoPushForm.pushCountLimitYellowBarShowContent = row.pushCountLimitYellowBarShowContent || "";
        this.$refs.pushForm.videoPushForm.clarityW = String(row.clarityW);
        this.$refs.pushForm.videoPushForm.clarityH = String(row.clarityH);
        // this.$refs.pushForm.videoPushForm.limitType = row.limitType || 1;
        this.$refs.pushForm.videoPushForm.paidCastType = this.stringToArray(row.paidCastType);
        this.$refs.pushForm.videoPushForm.dayLimitFreeTime = row.dayLimitFreeTime || 0;
        this.$refs.pushForm.videoPushForm.yellowBarShowTime = row.yellowBarShowTime || 0;
        this.$refs.pushForm.videoPushForm.countdownStartTime = row.countdownStartTime || 0;
        
        // 视频推送 - 限制全屏播放（方式2）
        if(row.pushLimitType && row.pushLimitType.includes('6')) {
          this.$refs.pushForm.videoPushForm.restrictionMode = '2';
          this.$refs.pushForm.videoPushForm.fullScreenTrialTime = row.pushFullFreeDuration || "";
          this.$refs.pushForm.videoPushForm.fullScreenYellowBarTime = row.pushYellowBarShowDuration || "";
          this.$refs.pushForm.videoPushForm.fullScreenCountdownTime = row.pushCountdownStartTime || "";
        }
        
        // 视频推送 - 服务降级（方式3）
        if(row.pushLimitTypeFun === '3') {
          this.$refs.pushForm.videoPushForm.restrictionMode = '3';
          this.$refs.pushForm.videoPushForm.restrictionTypes = ['8'];
        }
        
        // 局域网镜像
        this.$refs.lanMirrorConfig.mirrorConfigForm.limitType = this.stringToArray(row.lanMirrorLimitType);
        this.$refs.lanMirrorConfig.mirrorConfigForm.dayFreeCount = row.lanMirrorDailyFrequency || "";
        this.$refs.lanMirrorConfig.mirrorConfigForm.dayTimeLimit = row.lanMirrorSingleDurationMin || "";
        this.$refs.lanMirrorConfig.mirrorConfigForm.limit720p = row.lanMirrorDefinitionLimitFlag === '1' ? true : false;
        // 局域网镜像 - 720p限制 更多配置
        if(row.lanMirrorDefinitionLimitFlag === '1') {
          this.$refs.lanMirrorConfig.mirrorConfigForm.limit720pYellowBarTime = row.lanMirrorDefinitionYellowBarShowDuration || "";
          this.$refs.lanMirrorConfig.mirrorConfigForm.limit720pBuy = Number(row.lanMirrorDefinitionYellowBarHiddenOkBuyFlag) || 0;
          this.$refs.lanMirrorConfig.mirrorConfigForm.limit720pShowAgainTime = row.lanMirrorDefinitionYellowBarIntervalDuration || "";
        }

        // 云镜像
        this.$refs.cloudMirrorConfig.mirrorConfigForm.limitType = this.stringToArray(row.cloudMirrorLimitType);
        this.$refs.cloudMirrorConfig.mirrorConfigForm.dayFreeCount = row.cloudMirrorDailyFrequency || "";
        this.$refs.cloudMirrorConfig.mirrorConfigForm.dayTimeLimit = row.cloudMirrorSingleDurationMin || "";
        this.$refs.cloudMirrorConfig.mirrorConfigForm.limit720p = row.cloudMirrorDefinitionLimitFlag === '1' ? true : false;
        // 云镜像 - 720p限制 更多配置
        if(row.cloudMirrorDefinitionLimitFlag === '1') {
          this.$refs.cloudMirrorConfig.mirrorConfigForm.limit720pYellowBarTime = row.cloudMirrorDefinitionYellowBarShowDuration || "";
          this.$refs.cloudMirrorConfig.mirrorConfigForm.limit720pBuy = Number(row.cloudMirrorDefinitionYellowBarHiddenOkBuyFlag) || 0;
          this.$refs.cloudMirrorConfig.mirrorConfigForm.limit720pShowAgainTime = row.cloudMirrorDefinitionYellowBarIntervalDuration || "";
        }
        
        // 局域网镜像 - 服务降级（方式3）
        if(row.lanMirrorLimitTypeFun === '3') {
          this.$refs.lanMirrorConfig.mirrorConfigForm.restrictionMode = '3';
          this.$refs.lanMirrorConfig.mirrorConfigForm.limitType = ['8'];
        }

        // 云镜像 - 服务降级（方式3）
        if(row.cloudMirrorLimitTypeFun === '3') {
          this.$refs.cloudMirrorConfig.mirrorConfigForm.restrictionMode = '3';
          this.$refs.cloudMirrorConfig.mirrorConfigForm.limitType = ['8'];
        }
        
        // 局域网镜像蒙层遮盖
        if(row.lanMirrorLimitType && row.lanMirrorLimitType.includes('6')) {
          this.$refs.lanMirrorConfig.mirrorConfigForm.restrictionMode = '2';
          
          const dto = row.lanMirrorShadeLayerConfigDTO || {};
          this.$refs.lanMirrorConfig.mirrorConfigForm.maskTimeLimit = dto.shadeSingleDuration || "";
          this.$refs.lanMirrorConfig.mirrorConfigForm.maskYellowBarTime = dto.shadeYellowBarShowDuration || "";
          this.$refs.lanMirrorConfig.mirrorConfigForm.maskCountdownTime = dto.shadeCountdownStartTime || "";
          this.$refs.lanMirrorConfig.mirrorConfigForm.maskColorValue = dto.shadeColourValue || "";
          this.$refs.lanMirrorConfig.mirrorConfigForm.maskOpacity = dto.shadeTransparency || "";

          if (row.lanMirrorLimitTypeFun) {
             this.$refs.lanMirrorConfig.mirrorConfigForm.restrictionMode = String(row.lanMirrorLimitTypeFun);
          }
        }
        
        // 云镜像蒙层遮盖
        if(row.cloudMirrorLimitType && row.cloudMirrorLimitType.includes('6')) {
          this.$refs.cloudMirrorConfig.mirrorConfigForm.restrictionMode = '2';
          
          const dto = row.cloudMirrorShadeLayerConfigDTO || {};
          this.$refs.cloudMirrorConfig.mirrorConfigForm.maskTimeLimit = dto.shadeSingleDuration || "";
          this.$refs.cloudMirrorConfig.mirrorConfigForm.maskYellowBarTime = dto.shadeYellowBarShowDuration || "";
          this.$refs.cloudMirrorConfig.mirrorConfigForm.maskCountdownTime = dto.shadeCountdownStartTime || "";
          this.$refs.cloudMirrorConfig.mirrorConfigForm.maskColorValue = dto.shadeColourValue || "";
          this.$refs.cloudMirrorConfig.mirrorConfigForm.maskOpacity = dto.shadeTransparency || "";

          if (row.cloudMirrorLimitTypeFun) {
             this.$refs.cloudMirrorConfig.mirrorConfigForm.restrictionMode = String(row.cloudMirrorLimitTypeFun);
          }
        }
        
        // 图片
        if(this.addForm.rightConfigGroup.includes('4') && this.$refs.imageMirrorConfig) {
          this.$refs.imageMirrorConfig.mirrorConfigForm.restrictionMode = '2';
          this.$refs.imageMirrorConfig.mirrorConfigForm.limitType = this.stringToArray(row.imagePushLimitType) || ["6"];
          
          
          const dto = row.imagePushShadeLayerConfigDTO || {};
          this.$refs.imageMirrorConfig.mirrorConfigForm.maskTimeLimit = dto.shadeSingleDuration || "";
          this.$refs.imageMirrorConfig.mirrorConfigForm.maskYellowBarTime = dto.shadeYellowBarShowDuration || "";
          this.$refs.imageMirrorConfig.mirrorConfigForm.maskCountdownTime = dto.shadeCountdownStartTime || "";
          this.$refs.imageMirrorConfig.mirrorConfigForm.maskColorValue = dto.shadeColourValue || "";
          this.$refs.imageMirrorConfig.mirrorConfigForm.maskOpacity = dto.shadeTransparency || "";
          
          if (row.imagePushLimitTypeFun) {
             this.$refs.imageMirrorConfig.mirrorConfigForm.restrictionMode = String(row.imagePushLimitTypeFun);
          }
        }
        
        // 办公开会
        if(this.addForm.rightConfigGroup.includes('5') && this.$refs.officeMirrorConfig) {
          this.$refs.officeMirrorConfig.mirrorConfigForm.restrictionMode = '2';
          this.$refs.officeMirrorConfig.mirrorConfigForm.limitType = this.stringToArray(row.officeMeetingLimitType) || ["6"];
          
          const dto = row.officeMeetingShadeLayerConfigDTO || {};
          this.$refs.officeMirrorConfig.mirrorConfigForm.maskTimeLimit = dto.shadeSingleDuration || "";
          this.$refs.officeMirrorConfig.mirrorConfigForm.maskYellowBarTime = dto.shadeYellowBarShowDuration || "";
          this.$refs.officeMirrorConfig.mirrorConfigForm.maskCountdownTime = dto.shadeCountdownStartTime || "";
          this.$refs.officeMirrorConfig.mirrorConfigForm.maskColorValue = dto.shadeColourValue || "";
          this.$refs.officeMirrorConfig.mirrorConfigForm.maskOpacity = dto.shadeTransparency || "";

          if (row.officeMeetingLimitTypeFun) {
             this.$refs.officeMirrorConfig.mirrorConfigForm.restrictionMode = String(row.officeMeetingLimitTypeFun);
          }
        }

        // 图片/办公开会 - 服务降级（方式3）
        if(row.imagePushLimitTypeFun === '3') {
           this.$refs.imageMirrorConfig.mirrorConfigForm.restrictionMode = '3';
            this.$refs.imageMirrorConfig.mirrorConfigForm.limitType = ['8'];
        }
        if(row.officeMeetingLimitTypeFun === '3') {
           this.$refs.officeMirrorConfig.mirrorConfigForm.restrictionMode = '3';
            this.$refs.officeMirrorConfig.mirrorConfigForm.limitType = ['8'];
        }

        // 服务降级配置回填
        this.$nextTick(() => {
          if (row.videoPushDegradeConfigDTO && this.$refs.pushForm) {
            this.$refs.pushForm.$refs.degradeConfig.setData(row.videoPushDegradeConfigDTO);
          }
          if (row.lanMirrorDegradeConfigDTO && this.$refs.lanMirrorConfig) {
            this.$refs.lanMirrorConfig.$refs.degradeConfig.setData(row.lanMirrorDegradeConfigDTO);
          }
          if (row.cloudMirrorDegradeConfigDTO && this.$refs.cloudMirrorConfig) {
            this.$refs.cloudMirrorConfig.$refs.degradeConfig.setData(row.cloudMirrorDegradeConfigDTO);
          }
          if (row.imagePushDegradeConfigDTO && this.$refs.imageMirrorConfig) {
            this.$refs.imageMirrorConfig.$refs.degradeConfig.setData(row.imagePushDegradeConfigDTO);
          }
          if (row.officeMeetingDegradeConfigDTO && this.$refs.officeMirrorConfig) {
            this.$refs.officeMirrorConfig.$refs.degradeConfig.setData(row.officeMeetingDegradeConfigDTO);
          }
          if (row.friendShareDegradeConfigDTO && this.$refs.friendShareDegradeConfig) {
            this.$refs.friendShareDegradeConfig.setData(row.friendShareDegradeConfigDTO);
          }
        });
      });
      /** 打开对话框 */
      this.addDialog = true;
    },
    /** 删除事件 */
    delEvent(id) {
      console.log("点击删除按钮传入的id", id);
      /** 二次询问 */
      this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          /** 确认删除 */
          const { data } = await deleteScreenChargeLocal(id);
          console.log("删除的响应", data);
          if (data.code === 200) {
            Message.success("删除成功");
            /** 重新加载数据 */
            await this.loadList();
          } else {
            Message.error(data.message);
          }
        })
        .catch(() => {
          /** 取消删除 */
          Message.info("已取消删除");
        });
    },
    //^ ^--------------新增对话框内的事件-------------^ ^
    /** 视频推送验证 */
    validatePushForm() {
      if (this.addForm.rightConfigGroup.includes("1")) {
        return new Promise((resolve, reject) => {
          this.$refs.pushForm.validate((valid) => {
            if (valid) {
              resolve();
            } else {
              reject("视频推送验证失败");
            }
          });
        });
      } else {
        return Promise.resolve();
      }
    },

    /** 局域网镜像验证 */
    validateLanMirrorForm() {
      if (this.addForm.rightConfigGroup.includes("2")) {
        return new Promise((resolve, reject) => {
          this.$refs.lanMirrorConfig.validate((valid) => {
            if (valid) {
              resolve();
            } else {
              reject("局域网镜像验证失败");
            }
          });
        });
      } else {
        return Promise.resolve();
      }
    },

    /** 云镜像验证 */
    validateCloudMirrorForm() {
      if (this.addForm.rightConfigGroup.includes("3")) {
        return new Promise((resolve, reject) => {
          this.$refs.cloudMirrorConfig.validate((valid) => {
            if (valid) {
              resolve();
            } else {
              reject("云镜像验证失败");
            }
          });
        });
      } else {
        return Promise.resolve();
      }
    },

    /** 图片验证 */
    validateImageMirrorForm() {
      if (this.addForm.rightConfigGroup.includes("4")) {
        return new Promise((resolve, reject) => {
          this.$refs.imageMirrorConfig.validate((valid) => {
            if (valid) {
              resolve();
            } else {
              reject("图片验证失败");
            }
          });
        });
      } else {
        return Promise.resolve();
      }
    },

    /** 办公开会验证 */
    validateOfficeMirrorForm() {
      if (this.addForm.rightConfigGroup.includes("5")) {
        return new Promise((resolve, reject) => {
          this.$refs.officeMirrorConfig.validate((valid) => {
            if (valid) {
              resolve();
            } else {
              reject("办公开会验证失败");
            }
          });
        });
      } else {
        return Promise.resolve();
      }
    },

    /** 好友邀请验证：只有方式3服务降级，直接校验其降级配置 */
    validateFriendShareForm() {
      if (!this.showFriendShareConfig || !this.$refs.friendShareDegradeConfig) {
        return Promise.resolve();
      }
      return new Promise((resolve, reject) => {
        this.$refs.friendShareDegradeConfig.validate((valid) => {
          if (valid) {
            resolve();
          } else {
            reject("好友邀请验证失败");
          }
        });
      });
    },

    /** 点击选择收端渠道 */
    goSelectChannel() {
      this.currentSelectionType = SELECTION_TYPE_RECEIVE;
      this.terminalType = 2; // 收端
      this.tempAppId = this.addForm.channelIdList;
      this.selectDialog = true;
    },
    /** 点击选择发端渠道 */
    goSelectSendChannel() {
      this.currentSelectionType = SELECTION_TYPE_SEND;
      this.terminalType = 1; // 发端
      this.tempAppId = this.addForm.sendChannelIdList;
      this.selectDialog = true;
    },
    /** 多选渠道保存事件 */
    handleSelectConfirm(data) {
      console.log("多选渠道保存事件", data);
      const str = data.channel;
      const ids = data.appId;
      const names = data.nameStr;
      
      if (this.currentSelectionType === SELECTION_TYPE_SEND) {
         this.addForm.sendChannel = str.replace(/;/g, ",");
         this.addForm.sendChannelIdList = ids;
         this.addForm.sendChannelNameList = names;
      } else {
         /** 赋值给输入框 */
         this.addForm.receiveChannel = str.replace(/;/g, ",");
         /** 赋值给提交的字段 */
         this.addForm.channelIdList = ids;
         this.addForm.channelNameList = names;
      }
    },
    /** 确认添加按钮事件 */
    async confirmAdd() {
      console.log("添加/编辑的参数", this.addForm);
      this.$refs.addForm.validate(async (valid) => {
        const promises = [];
        if(this.addForm.rightConfigGroup.includes('1')) {
          promises.push(this.validatePushForm());
        }
        if(this.addForm.rightConfigGroup.includes('2')) {
          promises.push(this.validateLanMirrorForm());
        }
        if(this.addForm.rightConfigGroup.includes('3')) {
          promises.push(this.validateCloudMirrorForm());
        }
        if(this.addForm.rightConfigGroup.includes('4')) {
          promises.push(this.validateImageMirrorForm());
        }
        if(this.addForm.rightConfigGroup.includes('5')) {
          promises.push(this.validateOfficeMirrorForm());
        }
        if(this.showFriendShareConfig) {
          promises.push(this.validateFriendShareForm());
        }
        try {
          await Promise.all(promises);
        } catch (error) {
          console.error('子表单验证失败:', error);
          Message.error('表单验证失败，请检查输入内容');
          return;
        }
        // await this.validatePushForm();
        if (valid) {
          console.log("主表单验证通过");
          /** 根据是新增还是编辑执行相应的方法 */
          if (this.addForm.tvVersionType === 2) {
            if (
              this.addForm.tvVersionMin &&
              this.addForm.tvVersionMax &&
              Number(this.addForm.tvVersionMax) <
                Number(this.addForm.tvVersionMin)
            ) {
              Message.error("最大版本号不能小于最小版本号");
              return;
            }
          }
          /** 删除tvVersionMin, tvVersionMax, tvVersionSpecified */
          // eslint-disable-next-line no-unused-vars
          const { tvVersionMin, tvVersionMax, tvVersionSpecified, ...rest } =
            this.addForm;
          const params = {
            ...rest,
            tvVersion: this.tvVersionJoinHandler(this.addForm),
          };
          if (this.isEdit) {
            console.log("编辑");
            await this.Edit(params);
          } else {
            await this.Add(params);
          }
        } else {
          Message.error("表单验证失败");
          return false;
        }
      });
    },
    /**
     * 构建保存参数（新增和编辑公共逻辑）
     */
    buildSaveParams(params) {
      console.log("构建保存参数", this.$refs.pushForm, params);
      const saveParams = params;
      saveParams.channelIdList = typeof saveParams.channelIdList === "string" && saveParams.channelIdList.length > 0 ? saveParams.channelIdList.split(",") : [];
      saveParams.channelNameList = typeof saveParams.channelNameList === "string" && saveParams.channelNameList.length > 0 ? saveParams.channelNameList.split(",") : [];
      
      // 发端渠道处理
      saveParams.senderChannelType = this.addForm.sendChannelType; // 显式映射
      saveParams.senderChannelIdList = typeof saveParams.sendChannelIdList === "string" && saveParams.sendChannelIdList.length > 0 ? saveParams.sendChannelIdList.split(",") : [];
      saveParams.senderChannelNameList = typeof saveParams.sendChannelNameList === "string" && saveParams.sendChannelNameList.length > 0 ? saveParams.sendChannelNameList.split(",") : [];
      
      // 清理前端字段，避免误传
      delete saveParams.sendChannelIdList;
      delete saveParams.sendChannelNameList;
      delete saveParams.sendChannelType;
      // 删除UI显示用的字符串字段
      delete saveParams.receiveChannel;
      delete saveParams.sendChannel;
      saveParams.rightsConfigs = this.addForm.rightConfigGroup.join(",");
      
      if(this.addForm.rightConfigGroup.includes('1')) {
        // 视频推送
        saveParams.pushLimitTypeFun = this.$refs.pushForm.videoPushForm.restrictionMode;
        saveParams.pushLimitType = this.$refs.pushForm.videoPushForm.restrictionTypes.join(",");
        saveParams.paidCastType = this.$refs.pushForm.videoPushForm.paidCastType.join(",");
        const restrictionTypes = this.$refs.pushForm.videoPushForm.restrictionTypes
        if(restrictionTypes.includes('1')) {
          saveParams.dayLimit = this.$refs.pushForm.videoPushForm.dayLimit || "";
          saveParams.intervalTime = this.$refs.pushForm.videoPushForm.intervalTime;
          saveParams.popupDelayTime =
            Number(this.$refs.pushForm.videoPushForm.popupDelayTime) || 0;
          saveParams.secondPopupDelayTime =
            Number(this.$refs.pushForm.videoPushForm.secondPopupDelayTime) || 0;
          // 方式1-限次-小黄条配置
          saveParams.pushCountLimitYellowBarShowTime = this.$refs.pushForm.videoPushForm.pushCountLimitYellowBarShowTime || "";
          saveParams.pushCountLimitYellowBarShowContent = this.$refs.pushForm.videoPushForm.pushCountLimitYellowBarShowContent || "";
        }
        if(restrictionTypes.includes('2')) {
          saveParams.dayLimitFreeTime = parseInt(this.$refs.pushForm.videoPushForm.dayLimitFreeTime ) || 0;
          saveParams.yellowBarShowTime = this.$refs.pushForm.videoPushForm.yellowBarShowTime || 0;
          saveParams.countdownStartTime = this.$refs.pushForm.videoPushForm.countdownStartTime || 0;
        }
        if(restrictionTypes.includes('3')) {
          saveParams.clarityW = this.$refs.pushForm.videoPushForm.clarityW || "";
          saveParams.clarityH = this.$refs.pushForm.videoPushForm.clarityH || "";
        }
        if(restrictionTypes.includes('6')) {
          // 限制全屏播放（方式2）
          saveParams.pushFullFreeDuration = this.$refs.pushForm.videoPushForm.fullScreenTrialTime || "";
          saveParams.pushYellowBarShowDuration = this.$refs.pushForm.videoPushForm.fullScreenYellowBarTime || "";
          saveParams.pushCountdownStartTime = this.$refs.pushForm.videoPushForm.fullScreenCountdownTime || "";
        }
      }
      if(this.addForm.rightConfigGroup.includes('2')) {
        // 局域网镜像
        saveParams.lanMirrorLimitType = this.$refs.lanMirrorConfig.mirrorConfigForm.limitType.join(",");
        saveParams.lanMirrorLimitTypeFun = this.$refs.lanMirrorConfig.mirrorConfigForm.restrictionMode;
        
        const limitType = this.$refs.lanMirrorConfig.mirrorConfigForm.limitType
        if(limitType.includes('1')) {
          saveParams.lanMirrorDailyFrequency = this.$refs.lanMirrorConfig.mirrorConfigForm.dayFreeCount || "";
        }
        if(limitType.includes('2')) {
          saveParams.lanMirrorSingleDurationMin = this.$refs.lanMirrorConfig.mirrorConfigForm.dayTimeLimit || "";
        }
        if(limitType.includes('3')) {
          saveParams.lanMirrorDefinitionLimitFlag = this.$refs.lanMirrorConfig.mirrorConfigForm.limit720p ? 1 : 0;
          if (this.$refs.lanMirrorConfig.mirrorConfigForm.limit720p) {
             saveParams.lanMirrorDefinitionYellowBarShowDuration = parseInt(this.$refs.lanMirrorConfig.mirrorConfigForm.limit720pYellowBarTime) || 0;
             saveParams.lanMirrorDefinitionYellowBarHiddenOkBuyFlag = this.$refs.lanMirrorConfig.mirrorConfigForm.limit720pBuy;
             saveParams.lanMirrorDefinitionYellowBarIntervalDuration = parseInt(this.$refs.lanMirrorConfig.mirrorConfigForm.limit720pShowAgainTime) || 0;
          }
        }
        if(limitType.includes('6')) {
          // 蒙层遮盖 - DTO结构
          saveParams.lanMirrorShadeLayerConfigDTO = {
            shadeSingleDuration: parseInt(this.$refs.lanMirrorConfig.mirrorConfigForm.maskTimeLimit) || 0,
            shadeYellowBarShowDuration: parseInt(this.$refs.lanMirrorConfig.mirrorConfigForm.maskYellowBarTime) || 0,
            shadeCountdownStartTime: parseInt(this.$refs.lanMirrorConfig.mirrorConfigForm.maskCountdownTime) || 0,
            shadeColourValue: this.$refs.lanMirrorConfig.mirrorConfigForm.maskColorValue || "",
            shadeTransparency: Number(this.$refs.lanMirrorConfig.mirrorConfigForm.maskOpacity) || 0
          };
        }
      }
      if(this.addForm.rightConfigGroup.includes('3')) {
        // 云镜像
        saveParams.cloudMirrorLimitType = this.$refs.cloudMirrorConfig.mirrorConfigForm.limitType.join(",");
        saveParams.cloudMirrorLimitTypeFun = this.$refs.cloudMirrorConfig.mirrorConfigForm.restrictionMode;
        
        const limitType = this.$refs.cloudMirrorConfig.mirrorConfigForm.limitType
        if(limitType.includes('1')) {
          saveParams.cloudMirrorDailyFrequency = this.$refs.cloudMirrorConfig.mirrorConfigForm.dayFreeCount || "";
        }
        if(limitType.includes('2')) {
          saveParams.cloudMirrorSingleDurationMin = this.$refs.cloudMirrorConfig.mirrorConfigForm.dayTimeLimit || "";
        }
        if(limitType.includes('3')) {
          saveParams.cloudMirrorDefinitionLimitFlag = this.$refs.cloudMirrorConfig.mirrorConfigForm.limit720p ? 1 : 0;
          if (this.$refs.cloudMirrorConfig.mirrorConfigForm.limit720p) {
             saveParams.cloudMirrorDefinitionYellowBarShowDuration = parseInt(this.$refs.cloudMirrorConfig.mirrorConfigForm.limit720pYellowBarTime) || 0;
             saveParams.cloudMirrorDefinitionYellowBarHiddenOkBuyFlag = this.$refs.cloudMirrorConfig.mirrorConfigForm.limit720pBuy;
             saveParams.cloudMirrorDefinitionYellowBarIntervalDuration = parseInt(this.$refs.cloudMirrorConfig.mirrorConfigForm.limit720pShowAgainTime) || 0;
          }
        }
        if(limitType.includes('6')) {
          // 蒙层遮盖 - DTO结构
          saveParams.cloudMirrorShadeLayerConfigDTO = {
            shadeSingleDuration: parseInt(this.$refs.cloudMirrorConfig.mirrorConfigForm.maskTimeLimit) || 0,
            shadeYellowBarShowDuration: parseInt(this.$refs.cloudMirrorConfig.mirrorConfigForm.maskYellowBarTime) || 0,
            shadeCountdownStartTime: parseInt(this.$refs.cloudMirrorConfig.mirrorConfigForm.maskCountdownTime) || 0,
            shadeColourValue: this.$refs.cloudMirrorConfig.mirrorConfigForm.maskColorValue || "",
            shadeTransparency: Number(this.$refs.cloudMirrorConfig.mirrorConfigForm.maskOpacity) || 0
          };
        }
      }
      if(this.addForm.rightConfigGroup.includes('4')) {
        // 图片
        saveParams.imagePushLimitType = this.$refs.imageMirrorConfig.mirrorConfigForm.limitType.join(",");
        saveParams.imagePushLimitTypeFun = this.$refs.imageMirrorConfig.mirrorConfigForm.restrictionMode;
        
        const limitType = this.$refs.imageMirrorConfig.mirrorConfigForm.limitType
        if(limitType.includes('6')) {
          // 蒙层遮盖 - DTO结构
          saveParams.imagePushShadeLayerConfigDTO = {
            shadeSingleDuration: parseInt(this.$refs.imageMirrorConfig.mirrorConfigForm.maskTimeLimit) || 0,
            shadeYellowBarShowDuration: parseInt(this.$refs.imageMirrorConfig.mirrorConfigForm.maskYellowBarTime) || 0,
            shadeCountdownStartTime: parseInt(this.$refs.imageMirrorConfig.mirrorConfigForm.maskCountdownTime) || 0,
            shadeColourValue: this.$refs.imageMirrorConfig.mirrorConfigForm.maskColorValue || "",
            shadeTransparency: Number(this.$refs.imageMirrorConfig.mirrorConfigForm.maskOpacity) || 0
          };
        }
      }
      if(this.addForm.rightConfigGroup.includes('5')) {
        // 办公开会
        saveParams.officeMeetingLimitType = this.$refs.officeMirrorConfig.mirrorConfigForm.limitType.join(",");
        saveParams.officeMeetingLimitTypeFun = this.$refs.officeMirrorConfig.mirrorConfigForm.restrictionMode;
        
        const limitType = this.$refs.officeMirrorConfig.mirrorConfigForm.limitType
        if(limitType.includes('6')) {
          // 蒙层遮盖 - DTO结构
          saveParams.officeMeetingShadeLayerConfigDTO = {
            shadeSingleDuration: parseInt(this.$refs.officeMirrorConfig.mirrorConfigForm.maskTimeLimit) || 0,
            shadeYellowBarShowDuration: parseInt(this.$refs.officeMirrorConfig.mirrorConfigForm.maskYellowBarTime) || 0,
            shadeCountdownStartTime: parseInt(this.$refs.officeMirrorConfig.mirrorConfigForm.maskCountdownTime) || 0,
            shadeColourValue: this.$refs.officeMirrorConfig.mirrorConfigForm.maskColorValue || "",
            shadeTransparency: Number(this.$refs.officeMirrorConfig.mirrorConfigForm.maskOpacity) || 0
          };
        }
      }

      // 服务降级配置数据收集（方式3权益的 dayTime 统一取策略级输入 fan-out）
      if (this.addForm.rightConfigGroup.includes('1') && this.$refs.pushForm) {
        saveParams.videoPushDegradeConfigDTO = this.buildDegradeConfigData(this.$refs.pushForm, '1');
      }
      if (this.addForm.rightConfigGroup.includes('2') && this.$refs.lanMirrorConfig) {
        saveParams.lanMirrorDegradeConfigDTO = this.buildDegradeConfigData(this.$refs.lanMirrorConfig, '2');
      }
      if (this.addForm.rightConfigGroup.includes('3') && this.$refs.cloudMirrorConfig) {
        saveParams.cloudMirrorDegradeConfigDTO = this.buildDegradeConfigData(this.$refs.cloudMirrorConfig, '3');
      }
      if (this.addForm.rightConfigGroup.includes('4') && this.$refs.imageMirrorConfig) {
        saveParams.imagePushDegradeConfigDTO = this.buildDegradeConfigData(this.$refs.imageMirrorConfig, '4');
      }
      if (this.addForm.rightConfigGroup.includes('5') && this.$refs.officeMirrorConfig) {
        saveParams.officeMeetingDegradeConfigDTO = this.buildDegradeConfigData(this.$refs.officeMirrorConfig, '5');
      }
      // 好友邀请：无限制类型选择，限制类型恒为方式3服务降级
      if (this.showFriendShareConfig && this.$refs.friendShareDegradeConfig) {
        saveParams.friendShareLimitTypeFun = LIMIT_TYPE_FUN_DEGRADE;
        saveParams.friendShareDegradeConfigDTO = this.applyStrategyDayTime(
          this.$refs.friendShareDegradeConfig.getData(),
          RIGHTS_CODE_FRIEND_SHARE
        );
      }

      return saveParams;
    },

    /** 处理新增的逻辑 */
    async Add(params) {
      console.log("新增的参数", this.$refs.pushForm, params);
      /** 构建参数 */
      const addParams = this.buildSaveParams(params);
      console.log("处理后的参数", addParams);

      /** 调用接口 */
      const { data } = await addScreenChargeLocal(addParams);
      console.log("新增接口的响应", data);
      /** 如果成功 */
      if (data.code === 200) {
        Message.success("添加成功");
        /** 关闭对话框 */
        this.closeDialog();
        /** 刷新数据 */
        this.loadList();
      }
    },
    /** 处理编辑的逻辑 */
    async Edit(params) {
      /** 构建参数 */
      const editParams = this.buildSaveParams(params);
      console.log("处理后的参数", editParams);
      /** 调用接口 */
      const { data } = await updateScreenChargeLocal(editParams);
      console.log("编辑接口的响应", data);
      /** 如果成功 */
      if (data.code === 200) {
        Message.success("编辑成功");
        /** 关闭对话框 */
        this.closeDialog();
        /** 刷新数据 */
        this.loadList();
      }
    },
    /** 关闭对话框的事件 */
    closeDialog() {
      console.log("关闭对话框事件已执行");
      /** 清理数据为初始值 */
      this.addForm = {
        name: "",
        endType: 1,
        receiveChannel: "",
        channelIdList: "",
        channelNameList: [],
        sendChannelType: 1,
        sendChannel: "",
        sendChannelIdList: "",
        sendChannelNameList: [],
        // dayLimit: "",
        // intervalTime: "",
        // popupDelayTime: 0,
        // secondPopupDelayTime: 0,
        status: "",
        descr: "",
        rightConfigGroup: [],

        // clarityH: "",
        // clarityW: "",
        versionTargetType: 1,
        tvVersionType: 1,
        tvVersionMin: "",
        tvVersionMax: "",
        tvVersionSpecified: "",
        strategyDayTime: "",
        // limitType: 1,
        // paidCastType: [],
        // dayLimitFreeTime: 0,
        // yellowBarShowTime: 0,
        // countdownStartTime: 0,
      };
      // 重置方式3标记（好友邀请只有方式3，恒为 true）
      this.degradeMode3Flags = { "1": false, "2": false, "3": false, "4": false, "5": false, "6": true };
      /** 清除表单验证规则 */
      this.$nextTick(() => {
        this.$refs.addForm.clearValidate();
      });
      // this.$refs.addForm.clearValidate()
      /** 编辑状态恢复为初始 */
      this.isEdit = false;
      /** 关闭对话框 */
      this.addDialog = false;
    },
    /** 对话框打开前的初始化 */
    beforeOpenDialog() {
      // 如果是新增，重置所有子组件的表单
        console.log("对话框打开前的初始化");
        this.$refs.pushForm && this.$refs.pushForm.resetForm();
        this.$refs.lanMirrorConfig && this.$refs.lanMirrorConfig.resetForm();
        this.$refs.cloudMirrorConfig && this.$refs.cloudMirrorConfig.resetForm();
        this.$refs.imageMirrorConfig && this.$refs.imageMirrorConfig.resetForm();
        this.$refs.officeMirrorConfig && this.$refs.officeMirrorConfig.resetForm();
        this.resetFriendShareDegradeConfig();
        // 重置方式3标记：仅新增场景重置。编辑场景已在 editEvent 同步段按 row 整体赋值，
        // @open 早于 editEvent 的 nextTick 回填但晚于其同步段，此处若不按 isEdit 跳过会把编辑回显覆盖为 false。
        if (!this.isEdit) {
          this.degradeMode3Flags = { "1": false, "2": false, "3": false, "4": false, "5": false, "6": true };
        }
    },
    tvVersionJoinHandler(params) {
      if (params.tvVersionType === 2) {
        return `${params.tvVersionMin || ""},${params.tvVersionMax || ""}`;
      } else if (params.tvVersionType === 3) {
        return params.tvVersionSpecified;
      }
      return "";
    },
    tvVersionSplitHandler(type, value) {
      const initialValue = {
        tvVersionMin: "",
        tvVersionMax: "",
        tvVersionSpecified: "",
      };
      if (type === 2) {
        return {
          ...initialValue,
          tvVersionMin: value.split(",")[0],
          tvVersionMax: value.split(",")[1],
        };
      } else if (type === 3) {
        return {
          ...initialValue,
          tvVersionSpecified: value,
        };
      }
    },
    /**
     * 格式化TV版本号显示
     * @param {number} type - 版本类型：1-全部，2-区间，3-特定版本
     * @param {string} value - 版本号值
     * @returns {string} 格式化后的版本号显示文本
     */
    tvVersionFormatter(type, value) {
      const VERSION_TYPE = {
        ALL: 1,
        INTERVAL: 2,
        SPECIFIC: 3,
      };

      const formatInterval = (versionRange) => {
        if (!versionRange) return "";

        const [minVersion, maxVersion] = versionRange.split(",");
        const conditions = [];

        if (minVersion) conditions.push(`>=${minVersion}`);
        if (maxVersion) conditions.push(`<=${maxVersion}`);

        return conditions.join(",");
      };

      const formatMap = {
        [VERSION_TYPE.ALL]: "全部",
        [VERSION_TYPE.INTERVAL]: formatInterval(value),
        [VERSION_TYPE.SPECIFIC]: value,
      };

      return formatMap[type] || "";
    },
    tvVersionRangeValidator(rule, value, callback) {
      const type = this.addForm.tvVersionType;
      const min = this.addForm.tvVersionMin;
      const max = this.addForm.tvVersionMax;
      const specified = this.addForm.tvVersionSpecified;
      // SDK 版本号校验文案前缀（D7：SDK 时只允许数字，文案区分体验）
      const isSdk = this.addForm.versionTargetType === 2;
      const fieldPrefix = isSdk ? "SDK" : "";

      if (type === 2) {
        // 只能输入数字（APK / SDK 均限制）
        if (min && !/^\d+$/.test(min)) {
          callback(new Error(`${fieldPrefix}最小版本号只能输入数字`));
          return;
        }
        if (max && !/^\d+$/.test(max)) {
          callback(new Error(`${fieldPrefix}最大版本号只能输入数字`));
          return;
        }
        // 两个都没填
        if ((!min || min === "") && (!max || max === "")) {
          callback(new Error("请填写版本号"));
          return;
        }
        callback();
      } else if (type === 3) {
        // 只能输入数字和英文逗号（APK / SDK 均限制）
        if (!specified || specified === "") {
          callback(new Error("请输入指定版本号"));
          return;
        }
        if (!/^[\d,]+$/.test(specified)) {
          callback(new Error(`${fieldPrefix}多个版本号用英文逗号隔开，且只允许数字`));
          return;
        }
        callback();
      } else {
        callback();
      }
    },
    /** 版本目标类型格式化（列表展示用，null 视为 APK） */
    versionTargetTypeFormatter(value) {
      const opt = this.versionTargetTypeOptions.find((item) => item.value === value);
      return opt ? opt.label : "APK";
    },
    /** 配置端格式化（列表展示用，null 视为收端） */
    endTypeFormatter(value) {
      const opt = this.endTypeOptions.find((item) => item.value === value);
      return opt ? opt.label : "收端";
    },
    /**
     * 切换版本目标类型时的联动处理：
     * - 只清空收端渠道：收端渠道列表按 versionTargetType(APK/SDK) 过滤，已选的可能与新类型不匹配
     * - 发端渠道不联动清空：versionTargetType 是收端版本类型口径
     *   (APK型比 tvAuthInfoDTO.apk_ver、SDK型比 extractSdkVersionForMatch(version)，均取自收端设备)，
     *   发端是手机APP，不存在"版本类型"这个维度，发端渠道列表也不做 vipType 过滤
     *   (见 channelVipTypeFilter)，因此切换版本类型必须保留已选发端渠道，勿改回联动清空
     * - 已填的版本号不强制清空（APK/SDK 都是数字格式，校验保持一致）
     */
    handleVersionTargetTypeChange() {
      // 收端没有已选渠道则无需清空，也不提示
      if (!this.addForm.channelIdList) {
        return;
      }
      this.addForm.receiveChannel = "";
      this.addForm.channelIdList = "";
      this.addForm.channelNameList = [];
      Message.warning("已切换版本目标类型，已选的收端渠道已被清空，请重新选择");
    },
    getReceiveChannel(row) {
      if (row.channelType === 2) {
        return "全部渠道";
      } else {
        return row.receiveChannel;
      }
    },
    getSendChannel(row) {
      if (row.senderChannelType === 2) {
        return "全部渠道";
      } else {
        return row.sendChannel;
      }
    },
    formattedDayLimit(row) {
      if (row.limitType === 1) {
        return row.dayLimit === -1 ? "不限制" : row.dayLimit;
      } else {
        return "-";
      }
    },
    handleTabClick(tab) {
      this.currentTab = tab.name;
      this.searchParams.current = 1;
      this.loadList();
    },
    /** 查看日志 */
    async viewLog(row) {
      console.log("查看日志", row.id);
      try {
        const optSearch = this.$refs.optionLog.searchParams;
        const { data } = await getLogList({
          ...optSearch,
          subjectId: row.id,
          module: 7
        });
        
        console.log("查看日志的响应", data, optSearch);
        const list = cloneDeep(data.data.records);  
        optSearch.total = data.data.total || 0
        this.$refs.optionLog.show(
          list,
          row.id
        );
      } catch (error) {
        console.log("查看日志失败", error);
      }
    },
    /** 日志分页 */
    async reloadOpt(id) {
      console.log("日志分页", id);
      try {
        const optSearch = this.$refs.optionLog.searchParams;
        const { data } = await getLogList({
          ...optSearch,
          subjectId: id,
          module: 7
        });
        console.log("查看日志的响应", data);
        const list = cloneDeep(data.data.records);
        this.$refs.optionLog.list = list;
        this.$refs.optionLog.searchParams.total = data.data.total;
      } catch (error) {
        console.log("日志分页失败", error);
      }
    },
    /** 提交审核 */
    async submitAudit(id) {
      this.$confirm("确认提交审核吗？")
        .then(async () => {
          const { data } = await submitAudit(id);
          if (data.code === 200) {
            Message.success("提交审核成功");
            this.loadList();
          }
        })
        .catch(() => {
          Message.info("取消提交审核");
        });
    },
    /** 撤销审核 */
    async revokeAudit(id) {
      this.$confirm("确认撤销审核吗？")
        .then(async () => {
          const { data } = await cancelAudit(id);
          if (data.code === 200) {
            Message.success("撤销审核成功");
            this.loadList();
          }
        })
        .catch(() => {
          Message.info("取消撤销审核");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.search-contain {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.search-left {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
}

.overflow-ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.form-tip {
  color: #999;
  font-size: 12px;
  line-height: 1.4;
  margin-top: 4px;
}

/* 好友邀请配置块：与 mirror-config 的外框保持一致的视觉层级 */
.friend-share-config {
  padding: 20px 20px 30px;
  background-color: #f7f7f7;
  margin-bottom: 30px;

  &__title {
    font-weight: bold;
    margin-bottom: 10px;
    color: #000;
  }
}

.tv-version-input {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 130px;
  box-sizing: border-box;
  /deep/ .el-form-item {
    .el-form-item__label {
      font-size: 13px;
    }
  }
}

::v-deep .el-textarea__inner {
  padding-right: 55px !important;
  max-height: 100px !important;
}

.priority-tip {
  color: #333;

  &__title {
    font-size: 15px;
    font-weight: bold;
    margin: 0 0 8px;
  }

  &__desc {
    font-size: 13px;
    line-height: 1.6;
    margin: 0 0 8px;
  }

  &__list {
    margin: 0 0 8px;
    padding-left: 22px;
    font-size: 13px;
    line-height: 1.6;

    li {
      margin-bottom: 2px;
    }
  }

  &__rule {
    font-size: 13px;
    line-height: 1.6;
    margin: 0;
  }
}
</style>
<style lang="scss">
.el-tooltip__popper {
  max-width: 80% !important;
}
</style>